import { LandingPageConfig } from 'rangeConfig/@types';
import jonaxelDesignFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import jonaxelBrowseInspirationImg from '../../views/LandingPage/images/jonaxel_browse_inspiration.jpg';
import jonaxelGalleryConfig from './jonaxelGalleryConfig';

const jonaxelLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    titleTextColor: '#111111',
    backgroundColor: '#f0f0ee'
  },
  designFromScratch: {
    backgroundColor: '#E5DCD0',
    backgroundImgUrl: jonaxelDesignFromScratch
  },
  openDesign: {
    backgroundColor: '#5E655E',
    backgroundImgUrl: jonaxelBrowseInspirationImg,
    textColor: '#FFFFFF'
  },
  browseInspiration: {
    backgroundColor: '#9FB0A7',
    backgroundImgUrl: jonaxelBrowseInspirationImg,
    galleryConfig: jonaxelGalleryConfig
  }
};

export default jonaxelLandingPageConfig;
